import { DropdownList, SelectedOption } from '@cpm-pr1618001/ng-design-lib';
import { createAction, props } from '@ngrx/store';
import {
  AccountMessage,
  AccountNotification,
  Contacts,
  UserLogout,
} from '../state/user-management.state';

export const initUserManagement = createAction(
  '[User Management] INIT_USER_MANAGEMENT',
);

export const addProfileInfoToDropDownList = createAction(
  '[User Management] ADD_PROFILE_INFO_TO_DROP_DOWN_LIST',
  props<{ dropDownOption: DropdownList }>(),
);

export const logOutUser = createAction('[User Management]  LOG_OUT_USER');

export const logOutUserSuccess = createAction(
  '[User Management]  LOG_OUT_USER_SUCCESS',
  props<{ loggedOut: UserLogout }>(),
);

export const logOutUserError = createAction(
  '[User Management]  LOG_OUT_USER_ERROR',
);

export const getNotifications = createAction(
  '[User Management] GET_NOTIFICATIONS',
  props<{
    offsetLimit: number;
    maxResults: number;
    reload: boolean; // reload indicates whether append new notifications (false) or replace existing ones (true)
  }>(),
);

export const getNotificationsSuccess = createAction(
  '[User Management] GET_NOTIFICATIONS_SUCCESS',
  props<{ notifications: AccountNotification; reload: boolean }>(),
);

export const getNotificationsError = createAction(
  '[User Management] GET_NOTIFICATIONS_ERROR',
);

export const getMessages = createAction('[User Management] GET_MESSAGES');

export const getMessagesSuccess = createAction(
  '[User Management] GET_MESSAGES_SUCCESS',
  props<{ messages: AccountMessage[] }>(),
);

export const getMessagesError = createAction(
  '[User Management] GET_MESSAGES_ERROR',
);

export const getContacts = createAction('[User Management] GET_CONTACTS');

export const getContactsSuccess = createAction(
  '[User Management] GET_CONTACTS_SUCCESS',
  props<{ contacts: Contacts[] }>(),
);

export const getContactsError = createAction(
  '[User Management] GET_CONTACTS_ERROR',
);

export const selectedMenuDropdownOption = createAction(
  '[User Management] SELECTED_MENU_DROPDOWN_OPTION',
  props<{ selectedOption: SelectedOption }>(),
);
